
@if (errorMessage) {
  <p>
    {{ errorMessage }}
  </p>
}
